// Contact information on the Contact Page

export const ContactPageContactInfo = () => {
  return (
    <div className="contact-container">
      <div></div>
      <h3>LinkedIn</h3>
      <a href="https://www.linkedin.com/in/isaac-ola/" target={"_blank"}>
        https://www.linkedin.com/in/isaac-ola
      </a>
      <h3>GitHub</h3>
      <a href="https://github.com/IsaacOlarewaju/" target={"_blank"}>
        https://github.com/IsaacOlarewaju/
      </a>
      <h3>Email</h3>
      <a href="mailto:isaacola@me.com" target="_blank">
        isaacola@me.com
      </a>
      {/* <h3>Resume</h3>
      <a href="/images/CV.pdf" download target="_blank">
        Download Latest Resume
      </a> */}
    </div>
  );
};
